<template>
	<div>
		<WmsTable
			rowKey="deliveryReviewCode"
			v-bind="$attrs"
			:isPagination="query"
			:columns="newColumns"
			is-row-selection
			isExpanded_hidden
			@selectChange="selectChangeCall"
			@pageChange="pageChangeCall"
			:dataSource="dataSource"
			listener
			ref="wmsTable_review"
			:keepExpended="true"
			:hasHeader="false"
			:openAll="true"
		>
			<template #deliveryTaskCode="{ text, record }">
				{{ text }}
				<el-tag type="warning" v-if="record.allIncludeFlag === 1" effect="dark"
					>一价全包</el-tag
				>
        <li style="margin-left:20px;">
          <el-tag type="warning" v-if="record.overseasInvFlag==1">海外备货</el-tag>
        </li>
			</template>
			<template slot="platformOrderNo" slot-scope="{ text, record, index }">
				<div class="platformOrderNo">
					{{ record.platformOrderNo }}
          <div>
            <div v-if="record.miniFlag" class="mini-tag">mini</div>
          </div>
          <el-tag type="warning" effect="dark" v-if="record.priorityReviewFlag === 1">优先审单</el-tag>
          <el-tag type="danger" effect="dark" v-if="record.tiktokOrderFlag === 1" style="margin-left:4px;">tiktok订单</el-tag>
					<el-tag
						type="warning"
						effect="dark"
						v-if="record.allIncludeFlag === 1"
						>一价全包</el-tag
					>
          <li style="margin-left:20px;">
            <el-tag type="warning" v-if="record.overseasInvFlag===1">海外备货</el-tag>
          </li>
				</div>
			</template>
			<template slot="shipmentCodeAction" slot-scope="{ text, record, index }">
				<span
					@click="shipInvoiceDetails(record)"
					style="color: #40a9ff"
					class="shipmentCode__span"
					:class="{
						shipment__error: false,
					}"
				>
					{{ text }}
				</span>
			</template>
			<template slot="logisticsConfig" slot-scope="{ text, record, index }">
				{{ record.forwarderDesc || "-" }}
				<!-- <el-select v-model="record.forwarderDesc" placeholder="请选择" v-if="prentType == 'smallBag'"
          @change="tableForwarderChange($event, record, index)" :detail="record" :disabled="setUseable('logistics')"
          filterable @focus="selectOnfocus($event,record)" :loading="selectLoading">
          <el-option :label="item.forwarder + '-' + item.shippingType" :value="item.intForwarderConfigId"
            v-for="item in onSelectForwarderList" :key="item.intForwarderConfigId" style="max-width:300px"
            :title="item.forwarder + '-' + item.shippingType"></el-option>
        </el-select>
        <el-select v-model="record.forwarderDesc" placeholder="请选择" v-else :detail="record"
          :disabled="setUseable('logistics')" filterable>
        </el-select> -->
			</template>
			<template
				slot="auditIntForwarderConfigId"
				slot-scope="{ text, record, index }"
			>
				<el-select
					v-model="record.auditIntForwarderConfigIdDesc"
					placeholder="请选择"
					:detail="record"
					:disabled="true"
				>
				</el-select>
			</template>
			<div
				slot="action"
				style="display: flex; flex-wrap: wrap"
				slot-scope="{ text, record, index }"
			>
				<span
					class="span__btn"
					@click="toReview('submit', record)"
					v-if="['ToBeProcessed', 'warning'].includes($attrs.tableType)"
					>审单</span
				>
				<span
					class="span__btn"
					style="color: red; margin-left: 10px"
					@click="upError(record)"
					v-if="$attrs.tableType == 'ToBeProcessed'"
					>提交异常</span
				>
				<span
					class="span__btn"
					v-if="['Completed', 'ToBeConfirm'].includes($attrs.tableType)"
					@click="examineAgain(record)"
					>重新审单</span
				>
			</div>
			<template slot="expandedRender" slot-scope="deliveryItem">
				<WmsTable
					:hasHeader="false"
					bordered
					:columns="columns_SPU"
					:isPagination="false"
					:dataSource="deliveryItem.record.deliveryReviewSpuList"
					isExpanded_hidden
					:parentTable="$refs.wmsTable_review"
					:sonRecordId="deliveryItem.record.id"
					:keepExpended="true"
				>
					<ImgView
						slot="productImgAction"
						slot-scope="{ text, record, index }"
						:src="
							record.productType === 2 ? text.split(',')?.[0] ?? text : text
						"
					/>
					<template
						slot="productTransportationAttrDTOS"
						slot-scope="{ text, record, index }"
					>
						<span v-if="record.productTransportationAttrDTOS?.length">
							<span
								v-for="(i, index) in record.productTransportationAttrDTOS"
								:key="i.code"
								>{{ i.name }}
								<span
									v-if="
										index != record.productTransportationAttrDTOS?.length - 1
									"
									>,</span
								>
							</span>
						</span>
						<span v-else>-</span>
					</template>
					<template slot="totalSpuNums" slot-scope="{ text, record, index }">
						<span>{{ getTotalSpuNums(record) }}</span>
					</template>

					<template #reason="{ record }">
						<el-select
							:disabled="prentType == 'FBA'"
							v-if="
								$attrs.tableType === 'ToBeProcessed' ||
								$attrs.tableType === 'warning'
							"
							:value="record.auditReasonCode"
							@change="
								tableForwarderChange_spu(
									$event,
									record,
									'auditReasonCode',
									deliveryItem.record.deliveryReviewCode,
									deliveryItem.record.version
								)
							"
							filterable
						>
							<el-option label="请选择" :value="'AR_0000'"></el-option>
							<el-option
								:label="item.value"
								:value="item.code"
								v-for="item in reasonList"
								:key="item.code"
							>
							</el-option>
						</el-select>
						<span v-else>{{ record.auditReason || "-" }}</span>
					</template>
					<template #logisticsConfig="{ record }">
						<el-select
							:disabled="prentType == 'FBA' || disabledSelect(record)"
							v-if="
								$attrs.tableType === 'ToBeProcessed' ||
								$attrs.tableType === 'warning'
							"
							:value="record.auditIntForwarderConfigIdDesc"
							@change="
								tableForwarderChange_spu(
									$event,
									record,
									'auditIntForwarderConfigId',
									deliveryItem.record.deliveryReviewCode,
									deliveryItem.record.version,
									true
								)
							"
							filterable
							@focus="selectOnfocus($event, record, deliveryItem.record)"
							:loading="selectLoading"
						>
							<el-option label="请选择" value="0"></el-option>
							<!-- <el-option label="无可用货代公司" value="-1"></el-option> -->
							<!-- <el-option label="待确认货代公司" value="-2"></el-option> -->
							<el-option
								:label="
									item.intForwarderConfigId == -1
										? '无可用货代公司'
										: item.forwarder + '-' + item.shippingType
								"
								:value="item.intForwarderConfigId"
								v-for="item in onSelectForwarderList.filter(
									(v) =>
										v.intForwarderConfigId !=
										deliveryItem.record.intForwarderConfigId
								)"
								:key="item.intForwarderConfigId"
								style="max-width: 300px"
								:title="
									item.intForwarderConfigId == -1
										? '无可用货代公司'
										: item.forwarder + '-' + item.shippingType
								"
							></el-option>
						</el-select>
						<span v-else>{{
							record.auditForwarder == "无可用货代公司"
								? "无可用货代公司"
								: record.auditForwarder + "-" + record.auditShippingType
						}}</span>
					</template>
					<template #shopName="{ text, record }">
						<div>
							<a
								@click="jumpAliWangwang(record, deliveryItem)"
								v-if="serviceIds[record.shopCode]"
								>{{ text }}</a
							>
							<span v-else>{{ text }}</span>
						</div>
					</template>
					<template slot="expandedRender" slot-scope="{ record }">
						<WmsTable
							:hasHeader="false"
							bordered
							:columns="newColumns_son"
							:isPagination="false"
							:dataSource="record.deliveryReviewDetailList"
						>
							<ImgView
								slot="productImgAction"
								slot-scope="{ text, record, index }"
								:src="record.productType === 2 ? text.split(',')?.[0] : text"
							/>
							<div
								slot="productName"
								slot-scope="{ text, record, index }"
								style="display: flex; flex-direction: column"
							>
								<a :href="record.productLink" target="_blank">
									{{ text }}
								</a>
							</div>
							<template
								slot="shopProductSku"
								slot-scope="{ text, record, index }"
							>
								<div>
									{{ text }}
									<a
										v-if="record?.productCode"
										style="margin-left: 5px"
										target="_blank"
										:href="`https://s.theckb.com/ja/goods/${record?.productCode}`"
									>
										CKB链接</a
									>
								</div>
							</template>
							<template
								slot="productPriceCn"
								slot-scope="{ text, record, index }"
							>
								<div class="productPriceInput">
									<el-input
										placeholder="请输入内容"
										v-model="record.onShowPrice"
										:disabled="true"
									>
										<template slot="append">{{
											record.currencyCode ?? ""
										}}</template>
									</el-input>
								</div>
							</template>
							<template
								slot="productTransportationAttrDTOS"
								slot-scope="{ text, record, index }"
							>
								<!-- <span v-if="record3.record.productTransportationAttrDTOS?.length">
                  <span v-for="i, index in record3.record.productTransportationAttrDTOS" :key="i.code">{{ i.name }}
                    <span v-if="index != record3.record.productTransportationAttrDTOS.length - 1">,</span>
                  </span>
                </span>
                <span v-else-if="record.productTransportationAttrDTOS?.length">
                  <span v-for="i, index in record.productTransportationAttrDTOS" :key="i.code">{{ i.name }}
                    <span v-if="index != record.productTransportationAttrDTOS?.length - 1">,</span>
                  </span>
                </span>
                <span v-else>-</span> -->
								<div
									style="
										display: flex;
										align-items: center;
										justify-content: space-between;
									"
								>
									<!-- <el-select v-model="record.attrCodes" multiple @change="record.isEdit = true" :key="record.isEdit">
                    <el-option :label="item.attributeName" :value="item.attributeCode"
                      v-for="(item, index) in transportationAttributesList" :key="index"></el-option>
                  </el-select> -->
									<a-select
										v-model="record.attrCodes"
										mode="multiple"
										@change="record.isEdit = true"
										:maxTagCount="3"
										dropdownClassName="transportation-attr-code-select"
										style="flex: 1"
									>
										<a-select-option
											:value="item.attributeCode"
											v-for="(item, index) in transportationAttributesList"
											:key="index"
											>{{ item.attributeName }}</a-select-option
										>
									</a-select>
									<el-button
										v-if="record.isEdit"
										type="primary"
										size="mini"
										style="margin-left: 4px"
										@click="changeAttribute(record)"
										>保存</el-button
									>
								</div>
							</template>
							<template #reason="{ record }">
								<el-select
									:disabled="prentType == 'FBA'"
									v-if="
										$attrs.tableType === 'ToBeProcessed' ||
										$attrs.tableType === 'warning'
									"
									:value="record.auditReasonCode"
									@change="
										tableForwarderChange(
											$event,
											record,
											'auditReasonCode',
											deliveryItem.version
										)
									"
									filterable
								>
									<el-option label="请选择" :value="'AR_0000'"></el-option>
									<el-option
										:label="item.value"
										:value="item.code"
										v-for="item in reasonList"
										:key="item.code"
									>
									</el-option>
								</el-select>
								<span v-else>{{ record.auditReason || "-" }}</span>
							</template>
							<template #logisticsConfig="{ record }">
								<el-select
									:disabled="prentType == 'FBA' || disabledSelect(record)"
									v-if="
										$attrs.tableType === 'ToBeProcessed' ||
										$attrs.tableType === 'warning'
									"
									:value="record.auditIntForwarderConfigIdDesc"
									@change="
										tableForwarderChange(
											$event,
											record,
											'auditIntForwarderConfigId',
											deliveryItem.version,
											true
										)
									"
									filterable
									@focus="selectOnfocus($event, record, deliveryItem.record)"
									:loading="selectLoading"
								>
									<el-option label="请选择" value="0"></el-option>
									<!-- <el-option label="无可用货代公司" value="-1"></el-option> -->
									<!-- <el-option label="待确认货代公司" value="-2"></el-option> -->
									<el-option
										:label="
											item.intForwarderConfigId == -1
												? '无可用货代公司'
												: item.forwarder + '-' + item.shippingType
										"
										:value="item.intForwarderConfigId"
										v-for="item in onSelectForwarderList.filter(
											(v) =>
												v.intForwarderConfigId !=
												deliveryItem.record.intForwarderConfigId
										)"
										:key="item.intForwarderConfigId"
										style="max-width: 300px"
										:title="
											item.intForwarderConfigId == -1
												? '无可用货代公司'
												: item.forwarder + '-' + item.shippingType
										"
									></el-option>
								</el-select>
								<span v-else>{{
									record.auditForwarder == "无可用货代公司"
										? "无可用货代公司"
										: record.auditForwarder + "-" + record.auditShippingType
								}}</span>
							</template>
							<template #remark="{ text, record, index }">
								<div style="display: flex; align-items: center">
									<span>{{ record.auditRemark }}</span>
									<div
										class="span__btn"
										style="color: #40a9ff; flex-shrink: 0"
										@click="editRemark(record)"
									>
										编辑
									</div>
								</div>
							</template>
							<template #productSku="{ text, record }">
								<div>
									<a @click="openThirdUrl(record)">{{ text }}</a>
								</div>
							</template>
							<div
								slot="action"
								slot-scope="{ text, record, index }"
								style="display: flex; flex-direction: column"
							>
								<!-- <span class="span__btn" style="color: #40a9ff" @click="toUpdateDeclarationInfo(record)">
                  更新申报信息
                </span> -->
								<span
									class="span__btn"
									style="color: #40a9ff"
									@click="saveDeclarationInfo(record, 1)"
									v-if="
										($attrs.tableType === 'ToBeProcessed' ||
											$attrs.tableType === 'warning') &&
										record.productType !== 3
									"
								>
									维护申报信息
								</span>
								<span
									class="span__btn"
									style="color: #40a9ff"
									v-if="record.productType == 3"
									@click="checkCombinationProduct(record)"
									>查看子商品</span
								>
								<!-- <span class="span__btn" style="color: #40a9ff" @click="checkCombinationProduct(record)">查看子商品</span> -->
								<span
									class="span__btn"
									@click="openDeclarationCodeModal(record)"
									v-if="
										($attrs.tableType === 'ToBeProcessed' ||
											$attrs.tableType === 'warning') &&
										record.productType !== 3
									"
									>新增中文品名</span
								>
							</div>
						</WmsTable>
					</template>
				</WmsTable>
			</template>
			<template #invoicRemark="{ text }">
				<div>
					<a @click="openRemark(text)" v-if="text">详情</a>
				</div>
			</template>
		</WmsTable>

		<el-dialog
			:visible.sync="reviewDialogShow"
			width="1200px"
			top="2vh"
			@close="skip = []"
			:destroy-on-close="true"
			v-if="reviewDialogShow"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
		>
			<div slot="title" class="dialogTitle">审单</div>
			<el-collapse v-model="activeNames">
				<el-collapse-item name="1" v-if="reviewData.shippingAddress">
					<div
						slot="title"
						style="font-size: 16px; color: #303133; font-weight: 700"
					>
						收货地址
					</div>
					<el-descriptions title="" :column="5">
						<el-descriptions-item label="姓名">
							{{ reviewData.shippingAddress.name }}
						</el-descriptions-item>
						<el-descriptions-item label="公司名">
							{{ reviewData.shippingAddress.companyName }}
						</el-descriptions-item>
						<el-descriptions-item label="联系方式">
							{{ reviewData.shippingAddress.mobile }}
						</el-descriptions-item>
						<el-descriptions-item label="联系邮箱">
							{{ reviewData.shippingAddress.email }}
						</el-descriptions-item>
						<el-descriptions-item label="所属国家">
							{{ reviewData.shippingAddress.nation }}
						</el-descriptions-item>
						<el-descriptions-item label="省/洲">
							{{ reviewData.shippingAddress.province }}
						</el-descriptions-item>
						<el-descriptions-item label="所属城市">
							{{ reviewData.shippingAddress.city }}
						</el-descriptions-item>
						<el-descriptions-item label="所属区域">
							{{ reviewData.shippingAddress.area }}
						</el-descriptions-item>
						<el-descriptions-item label="邮编" :span="2">
							{{ reviewData.shippingAddress.postalCode }}
						</el-descriptions-item>
						<el-descriptions-item label="邮寄地址" :span="5">
							{{ reviewData.shippingAddress.address }}
						</el-descriptions-item>
					</el-descriptions>
				</el-collapse-item>
				<el-collapse-item
					name="2"
					v-if="reviewData.customsClearanceAddress && prentType != 'smallBag'"
				>
					<div
						slot="title"
						style="font-size: 16px; color: #303133; font-weight: 700"
					>
						清关地址
					</div>
					<el-descriptions title="" :column="5">
						<el-descriptions-item label="姓名">{{
							reviewData.customsClearanceAddress.name
						}}</el-descriptions-item>
						<el-descriptions-item label="公司名"
							>{{ reviewData.customsClearanceAddress.companyName }}
						</el-descriptions-item>
						<el-descriptions-item label="联系方式">{{
							reviewData.customsClearanceAddress.mobile
						}}</el-descriptions-item>
						<el-descriptions-item label="联系邮箱">{{
							reviewData.customsClearanceAddress.email
						}}</el-descriptions-item>
						<el-descriptions-item label="所属国家">{{
							reviewData.customsClearanceAddress.nation
						}}</el-descriptions-item>
						<el-descriptions-item label="省/洲">{{
							reviewData.customsClearanceAddress.province
						}}</el-descriptions-item>
						<el-descriptions-item label="所属城市">{{
							reviewData.customsClearanceAddress.city
						}}</el-descriptions-item>
						<el-descriptions-item label="所属区域">{{
							reviewData.customsClearanceAddress.area
						}}</el-descriptions-item>
						<el-descriptions-item label="邮编" :span="2"
							>{{ reviewData.customsClearanceAddress.postalCode }}
						</el-descriptions-item>
						<el-descriptions-item label="邮寄地址" :span="5">
							{{ reviewData.customsClearanceAddress.address }}
						</el-descriptions-item>
					</el-descriptions>
				</el-collapse-item>
			</el-collapse>

			<div style="margin-top: 10px">
				<el-descriptions :column="5" :colon="false">
					<template #title>
						<div>
							审单信息
							<el-popover
								placement="top-start"
								width="200"
								trigger="click"
								content="选择不合理后，会通知客户，客户需要选择处理方式"
							>
								<i
									slot="reference"
									class="el-icon-question"
									style="cursor: pointer"
								></i>
							</el-popover>
						</div>
					</template>
					<el-descriptions-item label="" :span="5">
						<el-form :inline="true" label-position="left" class="shipForm">
							<el-form-item label="货代公司是否合理：">
								<el-radio-group v-model="activeRadio">
									<el-radio :label="0">合理</el-radio>
									<el-radio :label="1">不合理，整单更换货代公司</el-radio>
									<el-radio :label="2" v-if="prentType != 'FBA'"
										>不合理，按SKU更换货代公司(没有设置建议货代公司的SKU将按照原货代公司运输)</el-radio
									>
								</el-radio-group>
							</el-form-item>
						</el-form>
					</el-descriptions-item>
					<el-descriptions-item label="" :span="5"
						><span style="font-size: 14px">原货代公司：{{ defaultShip }}</span>
					</el-descriptions-item>
					<el-descriptions-item label="" :span="5" v-if="activeRadio == 1">
						<el-form
							:model="reviveForm"
							style="width: 1000px"
							ref="reviveForm"
							:rules="reviveFormRules"
							:key="activeRadio"
						>
							<el-form-item label="异常原因：" prop="auditReasonCode">
								<el-select
									v-model="reviveForm.auditReasonCode"
									placeholder="全部"
									@change="wholeReasonChange"
								>
									<el-option
										:label="item.value"
										:value="item.code"
										v-for="item in reasonList"
										:key="item.code"
									>
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item
								label="建议货代公司："
								prop="auditIntForwarderConfigId"
							>
								<el-select
									v-model="reviveForm.auditIntForwarderConfigId"
									@change="forwarderChange"
									placeholder="全部"
									filterable
									:loading="selectLoading"
									:disabled="reviveForm.auditReasonCode == 'AR_0005'"
									style="width: 400px"
								>
									<el-option label="请选择" value="0"></el-option>
									<!-- <el-option label="无可用货代公司" value="-1"></el-option> -->
									<!-- <el-option label="待确认货代公司" value="-2"></el-option> -->
									<el-option
										v-for="(item, index) in onSelectForwarderList.filter(
											(v) =>
												v.intForwarderConfigId !=
												sourceShipConfig.intForwarderConfigId
										)"
										:key="index"
										:label="
											item.intForwarderConfigId == -1
												? '无可用货代公司'
												: item.forwarder + '-' + item.shippingType
										"
										:title="
											item.intForwarderConfigId == -1
												? '无可用货代公司'
												: item.forwarder + '-' + item.shippingType
										"
										:value="item.intForwarderConfigId"
									>
									</el-option>
								</el-select>
							</el-form-item>
						</el-form>
					</el-descriptions-item>

					<el-descriptions-item label="" :span="5">
						<el-form :inline="true" label-position="left">
							<el-form-item label="备注：">
								<el-input
									type="textarea"
									:autosize="{ minRows: 2, maxRows: 4 }"
									placeholder="请输入备注"
									v-model="reviveForm.remark"
								>
								</el-input>
							</el-form-item>
						</el-form>
					</el-descriptions-item>
				</el-descriptions>
			</div>
			<div style="margin-top: 10px">
				<el-descriptions title="商品信息" :column="5" :colon="false">
					<el-descriptions-item label="" :span="5">
						<el-table
							:data="reviewData.deliveryReviewSpuList"
							style="width: 1100px; position: relative; left: -10px"
							border
							height="350"
							header-cell-class-name="headerClass"
							:default-expand-all="activeRadio == 2"
							:key="activeRadio"
						>
							<el-table-column type="expand">
								<template slot-scope="scope">
									<el-table
										:data="scope.row.deliveryReviewDetailList"
										style="width: 100%"
									>
										<el-table-column
											label="商品图片"
											prop="productMainImg"
											width="100"
										>
											<template slot-scope="scopeL2">
												<ImgView
													:src="scopeL2.row.productImg"
													width="60"
													height="60"
												/>
											</template>
										</el-table-column>
										<el-table-column label="商品中文名" width="150">
											<template slot-scope="scopeL2">
												<a :href="scopeL2.row.productLink" target="_blank">{{
													scopeL2.row.productName
												}}</a>
											</template>
										</el-table-column>
										<el-table-column label="平台SKU" prop="productSku">
											<template slot-scope="scope">
												<div>
													{{ scope.row.productSku }}
													<a
														v-if="scope.row?.productCode"
														style="margin-left: 5px"
														target="_blank"
														:href="`https://s.theckb.com/ja/goods/${scope.row?.productCode}`"
													>
														CKB链接</a
													>
												</div>
											</template>
										</el-table-column>
										<el-table-column
											label="商品规格"
											prop="productPropertiesName"
										></el-table-column>
										<el-table-column
											label="商品材质（英文/中文）"
											prop="compilationMethod"
										>
											<template slot-scope="scope">
												<div>
													{{ scope.row.compilationMethod }} /
													{{ scope.row.compilationMethodEn || "-" }}
												</div>
											</template>
										</el-table-column>
										<el-table-column
											label="商品数量"
											prop="deliveryNums"
										></el-table-column>
										<el-table-column label="申报品名(英文/中文)" width="150">
											<template slot-scope="scope">
												<div>
													{{ scope.row.productCategoryEnglishName }} /
													{{ scope.row.productCategoryName }}
												</div>
											</template>
										</el-table-column>
										<el-table-column
											label="报关编码"
											prop="productDeclarationCode"
										></el-table-column>
										<el-table-column
											label="申报价格"
											prop="productPriceCn"
											width="150"
										>
											<template slot-scope="scope">
												<div class="productPriceInput">
													<el-input
														placeholder="请输入内容"
														v-model="scope.row.onShowPrice"
														:disabled="true"
													>
														<template slot="append">{{
															scope.row.currencyCode ?? ""
														}}</template>
													</el-input>
												</div>
											</template>
										</el-table-column>
										<el-table-column
											label="商品运输属性"
											prop="transportationAttrCode"
											width="250"
										>
											<template slot-scope="scope">
												<div
													style="
														display: flex;
														align-items: center;
														justify-content: space-between;
													"
												>
													<!-- <el-select v-model="scope.row.attrCodes" multiple @change="scope.row.isEdit = true" >
                            <el-option :label="item.attributeName" :value="item.attributeCode"
                              v-for="(item, index) in transportationAttributesList" :key="index"></el-option>
                          </el-select> -->
													<a-select
														v-model="scope.row.attrCodes"
														mode="multiple"
														@change="scope.row.isEdit = true"
														:maxTagCount="3"
														dropdownClassName="transportation-attr-code-select"
														style="flex: 1"
													>
														<a-select-option
															:value="item.attributeCode"
															v-for="(
																item, index
															) in transportationAttributesList"
															:key="index"
															>{{ item.attributeName }}</a-select-option
														>
													</a-select>
													<el-button
														v-if="scope.row.isEdit"
														type="primary"
														size="mini"
														style="margin-left: 4px"
														@click="changeAttribute(scope.row)"
														>保存</el-button
													>
												</div>
											</template>
										</el-table-column>
										<el-table-column
											label="异常原因"
											prop="productCode"
											v-if="activeRadio == 2"
											width="180"
											fixed="right"
										>
											<template slot-scope="scopeSon">
												<div style="position: relative; padding: 20px 0">
													<el-select
														v-model="scopeSon.row.auditReasonCode"
														filterable
														@change="
															(e) => {
																e == 'AR_0005' &&
																	(scopeSon.row.auditIntForwarderConfigId =
																		'-1');
																sortList(scope);
															}
														"
													>
														<el-option
															label="请选择"
															value="AR_0000"
														></el-option>
														<el-option
															:label="item.value"
															:value="item.code"
															v-for="item in reasonList"
															:key="item.code"
														></el-option>
													</el-select>
													<span
														v-if="
															(!scopeSon.row.auditReasonCode ||
																scopeSon.row.auditReasonCode == 'AR_0000') &&
															Number(scopeSon.row.auditIntForwarderConfigId)
														"
														class="tableWarning"
														>请选择异常原因</span
													>
												</div>
											</template>
										</el-table-column>
										<el-table-column
											label="建议货代公司"
											prop="productCode"
											v-if="activeRadio == 2"
											width="200"
											fixed="right"
										>
											<template slot-scope="scopeSon">
												<div style="position: relative; padding: 20px 0">
													<el-select
														v-model="scopeSon.row.auditIntForwarderConfigId"
														filterable
														:disabled="isChoice || disabledSelect(scopeSon.row)"
														:loading="selectLoading"
														popper-class="popperClass"
														@change="sortList(scope)"
													>
														<el-option label="请选择" value="0"></el-option>
														<!-- <el-option label="无可用货代公司" value="-1"></el-option> -->
														<!-- <el-option label="待确认货代公司" value="-2"></el-option> -->
														<el-option
															:label="
																item.intForwarderConfigId == -1
																	? '无可用货代公司'
																	: item.forwarder + '-' + item.shippingType
															"
															:value="item.intForwarderConfigId"
															v-for="item in onSelectForwarderList.filter(
																(v) =>
																	v.intForwarderConfigId !=
																	sourceShipConfig.intForwarderConfigId
															)"
															:key="item.intForwarderConfigId"
															style="max-width: 300px"
															:title="
																item.intForwarderConfigId == -1
																	? '无可用货代公司'
																	: item.forwarder + '-' + item.shippingType
															"
														></el-option>
													</el-select>
													<span
														v-if="
															(!Number(
																scopeSon.row.auditIntForwarderConfigId
															) &&
																scopeSon.row.auditReasonCode &&
																scopeSon.row.auditReasonCode != 'AR_0000') ||
															scopeSon.row.auditIntForwarderConfigId == -2
														"
														class="tableWarning"
														>请选择建议货代公司</span
													>
												</div>
											</template>
										</el-table-column>
									</el-table>
								</template>
							</el-table-column>
							<el-table-column
								label="商品图片"
								prop="productMainImg"
								width="100"
							>
								<template slot-scope="scope">
									<ImgView
										:src="scope.row.productMainImg"
										width="60"
										height="60"
									/>
								</template>
							</el-table-column>
							<el-table-column
								label="商品中文名"
								prop="productTitle"
							></el-table-column>
							<el-table-column
								label="商品SPU"
								prop="productCode"
							></el-table-column>
							<el-table-column
								label="异常原因"
								prop="auditReasonCode"
								v-if="activeRadio == 2"
							>
								<template slot-scope="scope">
									<el-select
										v-model="scope.row.auditReasonCode"
										@change="
											spuChangeSkuShip($event, scope.$index, 'auditReasonCode');
											sortList(scope);
										"
										filterable
									>
										<el-option label="请选择" value="AR_0000"></el-option>
										<el-option
											:label="item.value"
											:value="item.code"
											v-for="item in reasonList"
											:key="item.code"
										></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column
								label="建议货代公司"
								prop="compony"
								v-if="activeRadio == 2"
							>
								<template slot-scope="scope">
									<el-select
										v-model="scope.row.auditIntForwarderConfigId"
										@change="
											spuChangeSkuShip(
												$event,
												scope.$index,
												'auditIntForwarderConfigId'
											);
											sortList(scope);
										"
										filterable
										:disabled="isChoice || disabledSelect(scope.row)"
										:loading="selectLoading"
										popper-class="popperClass"
									>
										<el-option label="请选择" value="0"></el-option>
										<!-- <el-option label="无可用货代公司" value="-1"></el-option> -->
										<!-- <el-option label="待确认货代公司" value="-2"></el-option> -->
										<el-option
											:label="
												item.intForwarderConfigId == -1
													? '无可用货代公司'
													: item.forwarder + '-' + item.shippingType
											"
											:value="item.intForwarderConfigId"
											v-for="item in onSelectForwarderList.filter(
												(v) =>
													v.intForwarderConfigId !=
													sourceShipConfig.intForwarderConfigId
											)"
											:key="item.intForwarderConfigId"
											style="max-width: 300px"
											:title="
												item.intForwarderConfigId == -1
													? '无可用货代公司'
													: item.forwarder + '-' + item.shippingType
											"
										></el-option>
									</el-select>
								</template>
							</el-table-column>
						</el-table>
					</el-descriptions-item>
				</el-descriptions>
			</div>
			<!-- <div>
        <el-descriptions title="物流选择" :column="5" :colon="false">
          <el-descriptions-item label="" :span="5">
            <el-form :inline="true" :model="reviveForm" label-position="left">
              <el-form-item label="货代公司：">
                <el-select v-model="reviveForm.auditIntForwarderConfigId" @change="forwarderChange" placeholder="全部"
                  filterable @focus="selectOnfocus($event,reviewData,'dialog')" :loading="selectLoading">
                  <el-option v-for="(item, index) in onSelectForwarderList" :key="index"
                    :label="item.forwarder + '-' + item.shippingType" :title="item.forwarder + '-' + item.shippingType"
                    :value="item.intForwarderConfigId">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="原因：" v-if="prentType != 'smallBag'">
                <el-select v-model="reviveForm.reason" placeholder="全部">
                  <el-option :label="item.zh" :value="item.id" v-for="item in reasonList" :key="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-descriptions-item>

          <el-descriptions-item label="" :span="5">
            <el-form :inline="true" :model="reviveForm" label-position="left">
              <el-form-item label="备注：">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入备注"
                  v-model="reviveForm.remark">
                </el-input>
              </el-form-item>
            </el-form>
          </el-descriptions-item>
        </el-descriptions>
      </div> -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="skipToNext" style="float: left">跳过</el-button>
				<el-button @click="reviewDialogShow = false">关闭</el-button>
				<el-button type="" @click="reviewSubmit(false)">{{
					reviveForm.auditIntForwarderConfigId != isRejectId &&
					reviveForm.reason != undefined
						? "驳回"
						: "提交"
				}}</el-button>
				<el-button
					:type="
						reviveForm.auditIntForwarderConfigId != isRejectId &&
						reviveForm.reason != undefined
							? 'danger'
							: 'primary'
					"
					@click="reviewSubmit(true)"
					>{{
						`${
							reviveForm.auditIntForwarderConfigId != isRejectId &&
							reviveForm.reason != undefined
								? "驳回"
								: "提交"
						}并审核下一单`
					}}</el-button
				>
			</span>
		</el-dialog>

		<el-dialog
			:visible.sync="saveDeclarationInfoVisible"
			width="500px"
			v-if="saveDeclarationInfoVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
		>
			<div slot="title" class="dialogTitle">维护申报信息</div>
			<el-form
				label-width="150px"
				class="dialogForm"
				style="margin-top: 30px"
				:model="saveDeclarationData"
				ref="saveDeclarationDataForm"
				:rules="{
					productDeclarationId: [
						{ required: true, message: '请选择申报品名', trigger: 'blur' },
					],
					// compilationMethod: [
					//   {
					//     required: true,
					//     message: '请选择编制方式和材质',
					//     trigger: 'blur',
					//   },
					// ],
				}"
			>
				<el-form-item label="申报品名" prop="productDeclarationId">
					<el-select
						style="float: left"
						placeholder="请选择申报品名"
						v-model="saveDeclarationData.productDeclarationId"
						filterable
					>
						<el-option
							:label="item.productItemCategoryZh"
							:value="item.productCustomsId"
							v-for="item in customsList"
							:key="item.productCustomsId"
						></el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item label="编制方式和材质" prop="compilationMethod" filterable>
          <el-select style="float: left" placeholder="请选择编制方式和材质" v-model="saveDeclarationData.compilationMethod"
            filterable>
            <el-option :label="item.compilationMethod" :value="item.compilationMethod"
              v-for="item in compilationMethodList" :key="item.compilationMethod"></el-option>
          </el-select>
        </el-form-item> -->
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="saveDeclarationInfoVisible = false">取消</el-button>
				<el-button type="primary" @click="saveDeclaration">确定</el-button>
			</span>
		</el-dialog>

		<el-dialog
			:visible.sync="editRemarkVisible"
			:destroy-on-close="true"
			width="400px"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
		>
			<div slot="title" class="dialogTitle">编辑备注</div>
			<el-form style="margin-top: 30px">
				<el-form-item label="备注">
					<el-input
						style="width: 300px; float: left"
						:maxlength="20"
						type="textarea"
						:autosize="{ minRows: 1, maxRows: 2 }"
						placeholder="请输入备注"
						v-model="editRemarkInfo.auditRemark"
					>
					</el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="editRemarkVisible = false">取消</el-button>
				<el-button type="primary" @click="confirmRemark">确定</el-button>
			</span>
		</el-dialog>

		<el-dialog :visible.sync="combinationProductVisible" width="1300px">
			<div slot="title" class="dialogTitle">查看子商品</div>
			<WmsTable
				:hasHeader="false"
				:columns="combinationColumns"
				:dataSource="combinationProductList"
				:scrollY="500"
				:isPagination="false"
			>
				<ImgView
					slot="productImg"
					slot-scope="{ text, record, index }"
					:src="text"
				/>
				<div slot="action" slot-scope="{ text, record, index }">
					<span
						class="span__btn"
						style="color: #40a9ff"
						@click="saveDeclarationInfo(record, 2)"
						v-if="
							($attrs.tableType === 'ToBeProcessed' ||
								$attrs.tableType === 'warning') &&
							record.productType !== 3
						"
					>
						维护申报信息
					</span>
					<div>
						<span
							class="span__btn"
							@click="openDeclarationCodeModal(record, 2)"
							v-if="
								($attrs.tableType === 'ToBeProcessed' ||
									$attrs.tableType === 'warning') &&
								record.productType !== 3
							"
							>新增中文品名</span
						>
					</div>
				</div>
				<div slot="productSku" slot-scope="{ text, record, index }">
					<a :href="record.productLink" target="_blank">{{ text }}</a>
				</div>
			</WmsTable>
		</el-dialog>
		<AbnormalDialog ref="abnormalDialogRef" />
		<RemarkDialog ref="remarkDialogRef" />
		<DeclarationCodeModal
			ref="declarationCodeModalRef"
			@submit="submitDeclarationCode"
		/>
		<EditProductCategoryZh
			ref="editProductCategoryZhRef"
			@submit="submitEditProductCategoryZh"
		/>
	</div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import ImgView from "@/components/ImgView";
import FBAFun from "@/views/outOfStock/internationalShipment/components/FBAFun";
import { Table, Select } from "ant-design-vue";
import AbnormalDialog from "./abnormalDialog.vue";
import {
	columns,
	columns_fixed,
	columns_fixed_smallBag,
	columns_SPU,
	columnsSon,
	columns_ToBeProcessed,
	columns_ToBeConfirm,
	columns_Completed,
	columnsSon_ToBeProcessed,
	columnsSon_warning,
	columns_warning,
	columnsSon_Completed,
	combinationColumns,
	columnsSon_ToBeConfirm,
	combineColumns,
} from "./InterListData";
import {
	updateDeclarationInfo,
	reviewInfo,
	singleReview,
	getClientForwarder,
	abnormalCommit,
	abnormalCommit_spu,
	abnormalCommit_sku,
	customsConfirm,
	combinationProduct,
	deliveryReviewApi,
	getTransportationAttributesListApi,
	getWangWangUrlApi,
	updateSkuTransportationAttrApi,
	checkAbnormalDeliveryReviewApi,
	getCombinationItemListApi,
} from "@/apis/outStock";
import { processingStatusList, deliveryTypes } from "./../data";
import RemarkDialog from "./remarkDialog.vue";
import DeclarationCodeModal from "./declarationCodeModal.vue";
import EditProductCategoryZh from "./EditProductCategoryZh/index.vue";
export default {
	name: "InterList",
	components: {
		[Table.name]: Table,
		WmsTable,
		ImgView,
		AbnormalDialog,
		RemarkDialog,
		[Select.name]: Select,
		[Select.Option.name]: Select.Option,
		DeclarationCodeModal,
		EditProductCategoryZh,
	},
	props: {
		prentType: {
			type: String,
		},
		layout: {
			type: String,
			default: () => {
				return "";
			},
		},
		total: {
			type: [String, Number],
		},
		dataSource: {
			type: Array,
			default: () => {
				return [];
			},
		},
		forwarder: {
			type: Array,
			default: () => [],
		},
		compilationMethodList: {
			type: Array,
			default: () => [],
		},
		customsList: {
			type: Array,
			default: () => [],
		},
		reasonList: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			combineColumns,
			columns,
			columns_SPU,
			columnsSon,
			combinationColumns,
			processingStatusList,
			// reasonList,
			selRow: [],
			targetLeft: 0,
			query: {
				current: 1,
				pageSize: 20,
				total: 0,
			},
			reviewDialogShow: false,
			sourceShipConfig: {},
			reviewData: {
				auditIntForwarderConfigId: "",
			},
			reviveForm: {
				remark: "",
				auditReasonCode: 0,
				auditIntForwarderConfigId: 0,
			},
			isRejectId: 0,
			skip: [],
			selectLoading: false,
			onSelectForwarderList: [],
			activeNames: ["1", "2"],

			saveDeclarationInfoVisible: false,
			saveDeclarationData: {
				compilationMethod: "",
				productDeclarationId: "",
			},

			activeRadio: 0,

			editRemarkVisible: false,
			editRemarkInfo: {},

			reviveFormRules: {
				auditReasonCode: [
					{
						required: true,
						validator: (rule, value, callback) => {
							console.log(rule, value);
							if (!value) {
								callback(new Error("请选择异常原因"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
				auditIntForwarderConfigId: [
					{
						required: true,
						validator: (rule, value, callback) => {
							console.log(rule, value);
							if (!value) {
								callback(new Error("请选择建议货代公司"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
			},

			combinationProductList: [],
			combinationProductVisible: false,
			transportationAttributesList: [],
			serviceIds: {},
			combineProductSku: "",
			isChoice: false,
		};
	},
	watch: {
		total: {
			handler: function (newVal, oldVal) {
				this.query.total = newVal;
			},
			immediate: true,
			keep: true,
		},
		dataSource: {
			handler: function (newVal) {
				console.log("newVal", newVal);
				let shopCodes = [];
				newVal.forEach((item) => {
					item.id = "review" + item.id;
					item.deliveryReviewSpuList.forEach((spu) => {
						spu.id = item.id + spu.productCode + "";
						if (!shopCodes.includes(spu.shopCode)) {
							shopCodes.push(spu.shopCode);
						}
					});
				});
				if (shopCodes.length) {
					getWangWangUrlApi(shopCodes.map((item) => ({ shopCode: item }))).then(
						(res) => {
							res.data.forEach((v) => {
								this.serviceIds[v.shopCode] = v.shopCustomerServiceId;
							});
						}
					);
				}
			},
			immediate: true,
			keep: true,
		},
	},
	computed: {
		newColumns: function () {
			console.log("this.prentType", this.prentType, this.$attrs.tableType);
			let _columns = [...columns];
			if (this.prentType != "smallBag") {
				_columns = columns_fixed.concat(_columns);
			} else {
				_columns = columns_fixed_smallBag.concat(_columns);
			}
			if (this.$attrs.tableType === "warning") {
				_columns = _columns.concat(columns_warning);
			}
			if (["ToBeProcessed", "warning"].includes(this.$attrs.tableType)) {
				_columns = _columns.concat([
					{
						title: "复购单经理",
						dataIndex: "managerName",
						key: "managerName",
						rowKey: "key",
					},
					{
						title: "营销经理",
						dataIndex: "marketingManagerName",
						key: "marketingManagerName",
						rowKey: "key",
					},
				]);
			}
			if (this.$attrs.tableType === "ToBeConfirm") {
				_columns = _columns.concat(
					columns_ToBeConfirm.filter(
						(v) => !v.prentType || v.prentType.includes(this.prentType)
					)
				);
			}
			if (this.$attrs.tableType === "Completed") {
				_columns = _columns.concat(
					columns_ToBeConfirm.filter(
						(v) => !v.prentType || v.prentType.includes(this.prentType)
					),
					columns_Completed
				);
			}
			if (this.prentType != "smallBag") {
				// 大包和fba tab新增业务备注字段
				const c = {
					title: "业务备注",
					dataIndex: "invoicRemark",
					key: "invoicRemark",
					scopedSlots: {
						customRender: "invoicRemark",
					},
				};
				const length = _columns.push(c);
				const index = _columns.findIndex((v) => v.title === "店铺名称");
				if (index) {
					[_columns[length - 1], _columns[index]] = [
						_columns[index],
						_columns[length - 1],
					];
				}
			}
			// if (["ToBeProcessed", "warning", "Completed"].includes(this.$attrs.tableType)) {

			// }
			_columns = _columns.concat(columns_ToBeProcessed);
			return _columns;
		},
		// sku table
		newColumns_son: function () {
			let _columns = [...columnsSon];
			// if (this.$attrs.tableType === "ToBeProcessed") {
			//   _columns = _columns.concat(columnsSon_ToBeProcessed);
			// }
			if (this.$attrs.tableType === "warning") {
				_columns = _columns.concat(columnsSon_warning);
			}
			if (this.$attrs.tableType === "ToBeConfirm") {
				_columns = _columns.concat(columnsSon_ToBeConfirm);
			}
			if (this.$attrs.tableType === "Completed") {
				_columns = _columns
					.concat(columnsSon_ToBeConfirm)
					.concat(columnsSon_Completed);
			}
			_columns = _columns.concat(columnsSon_ToBeProcessed);
			return _columns;
		},
	},
	methods: {
		/** 获取spu级别的总商品数量 */
		getTotalSpuNums(row) {
			const arr = row.deliveryReviewDetailList || [];
			const num = arr.reduce((pre, cur) => {
				return pre + (cur.deliveryNums ?? 0);
			}, 0);
			return num;
		},
		setUseable(Str) {
			return !this.layout.includes(Str);
		},
		matchForwarder(data) {
			let has = this.forwarder.some((item) => {
				if (item.intForwarderConfigId == data.wmsIntForwarderConfigId) {
					return true;
				}
			});
			has = has
				? data.wmsIntForwarderConfigId
				: data.wmsForwarder + "-" + data.wmsShippingType;
			return has;
		},
		pageChangeCall: function (payload) {
			this.query.current = payload.current;
			this.query.pageSize = payload.pageSize;
			this.$emit("pageChange", payload);
		},
		selectChangeCall: function (rows) {
			if (this.prentType == "smallBag") {
				if (this.selRow.length < rows.length) {
					if (
						rows.some(
							(v) => v.receivingNationCode != rows[0].receivingNationCode
						)
					) {
						this.$message.warning("不能同时勾选多个收货国家的单据");
						this.$refs.wmsTable_review.resetSel(this.selRow);
						return;
					}
				}
			}
			this.selRow = rows;
			this.$emit("selectChange", rows);
		},
		resetPage() {
			this.query.current = 1;
			this.$refs.wmsTable_review.resetSel();
		},
		//子table宽度计算
		columsWitchCalc(column) {
			let width = 0;
			column.forEach((item) => {
				width += item.width || 188;
			});
			return width;
		},
		//更新申报信息
		toUpdateDeclarationInfo(record) {
			console.log(record);
			let params = {
				deliveryReviewDetailId: record.id,
				deliveryTaskCode: record.deliveryTaskCode,
				productSku: record.productSku,
			};
			updateDeclarationInfo(params).then((res) => {
				console.log(res);
				this.$message.success(res.data);
				this.$emit("refeash");
			});
		},
		saveDeclarationInfo(record, type) {
			if (record.productType !== 2) {
				console.log("saveDeclarationInfo", record);
				// 普通商品走新弹窗
				this.$refs.editProductCategoryZhRef.open(
					{
						...record,
						productItemCategoryZh: record.productCategoryName,
					},
					type
				);
				return;
			}
			// 如果是oem则走原逻辑
			this.saveDeclarationInfoVisible = true;
			let info = { ...record };
			if (
				this.customsList.every(
					(v) => v.productCustomsId != record.productDeclarationId
				)
			) {
				info.productDeclarationId = record.productCategoryName;
			}
			this.saveDeclarationData = info;
		},
		checkCombinationProduct(record) {
			if (record?.productSku) {
				this.combineProductSku = record.productSku;
			}
			getCombinationItemListApi({ productSku: this.combineProductSku }).then(
				({ code, data }) => {
					if (code == 0) {
						this.combinationProductList = data;
						this.combinationProductVisible = true;
					}
				}
			);
		},
		toReview(type = "submit", record = false) {
			let params;
			if (type == "submit") {
				// 一口价禁止修改物流信息
				this.isChoice = record.allIncludeFlag === 1;
				params = {
					deliveryType: deliveryTypes[this.prentType],
					deliveryReviewCode: record.deliveryReviewCode,
					deliveryTaskCode: record.deliveryTaskCode,
				};
			} else if (type == "next") {
				params = {
					deliveryType: deliveryTypes[this.prentType],
					deliveryReviewCode: "",
					deliveryTaskCode: "",
					processingStatus: processingStatusList[this.$attrs.tableType],
				};
			} else {
				params = {
					deliveryType: deliveryTypes[this.prentType],
					notInDeliveryReviewCodes: this.skip,
					processingStatus: processingStatusList[this.$attrs.tableType],
				};
			}
			reviewInfo(params).then((res) => {
				if (res.code == 0) {
					(this.reviewData = {}),
						(this.reviveForm = {
							remark: "",
						});
					if (res.data.deliveryReviewSpu) {
						res.data.deliveryReviewSpu.forEach((item) => {
							Object.keys(item).forEach((key) => {
								if (!item[key]) {
									item[key] = "-";
								}
							});
							item.id = item.productCode;
						});
					}
					if (res.data.shippingAddress) {
						Object.keys(res.data.shippingAddress).forEach((key) => {
							if (!res.data.shippingAddress[key]) {
								res.data.shippingAddress[key] = "-";
							}
						});
					}
					if (res.data.customsClearanceAddress) {
						Object.keys(res.data.customsClearanceAddress).forEach((key) => {
							if (!res.data.customsClearanceAddress[key]) {
								res.data.customsClearanceAddress[key] = "-";
							}
						});
					}
					this.reviewData = res.data;
					this.reviewData.deliveryReviewSpuList.forEach((v) => {
						v.deliveryReviewDetailList.forEach((y) => {
							y.onShowPrice =
								y.currencyCode == "KRW" ? y.customsPriceKr : y.customsPrice;
							y.attrCodes = y.productTransportationAttrDTOS?.map((v) => v.code);
							y.isEdit = false;
						});
					});
					this.sortList({ row: {} }, true);
					this.reviewData = JSON.parse(JSON.stringify(this.reviewData));
					this.isRejectId = res.data.logisticsChoose.intForwarderConfigId;
					this.activeRadio = res.data.auditType ? res.data.auditType : 0;
					//dialog 货代公司初始值
					this.defaultShip =
						res.data.logisticsChoose.forwarder +
						"-" +
						res.data.logisticsChoose.shippingType;
					let data = this.forwarder.filter(
						(item) =>
							item.intForwarderConfigId ==
							res.data.logisticsChoose.intForwarderConfigId
					)[0];
					if (!data || data.length == 0) {
						// this.reviveForm.auditIntForwarderConfigId =
						//   res.data.logisticsChoose.forwarder +
						//   res.data.logisticsChoose.shippingType;
						// this.reviveForm.logisticsIntFalse =
						//   res.data.logisticsChoose.intForwarderConfigId;
						this.sourceShipConfig = {
							auditIntShipConfigId: res.data.auditIntShipConfigId,
							// auditDistribution:res.data.auditDistribution,
							auditIntForwarderConfigId:
								res.data.logisticsChoose.intForwarderConfigId,
							intForwarderConfigId:
								res.data.logisticsChoose.intForwarderConfigId,
						};
					} else {
						// this.reviveForm.auditIntShipConfigId =
						//   res.data.auditIntShipConfigId;
						// this.reviveForm.auditDistribution = res.data.auditDistribution;
						// this.reviveForm.auditShippingType = data.shippingType;
						// this.reviveForm.auditForwarder = data.forwarder;
						this.sourceShipConfig = {
							auditIntShipConfigId: res.data.auditIntShipConfigId,
							// auditDistribution:res.data.auditDistribution,
							auditShippingType: data.shippingType,
							auditForwarder: data.forwarder,
							auditIntForwarderConfigId:
								res.data.logisticsChoose.intForwarderConfigId,
							intForwarderConfigId:
								res.data.logisticsChoose.intForwarderConfigId,
						};
					}
					this.onSelectForwarderList = [
						{
							forwarder: "无可用货代公司",
							intForwarderConfigId: "-1",
							shippingType: 0,
						},
					].concat(res.data.forwarderList);
					this.reviewDialogShow = true;
				}
			});
		},
		spuChangeSkuShip(val, index, name) {
			this.reviewData.deliveryReviewSpuList[
				index
			].deliveryReviewDetailList.forEach((v) => {
				if (
					name != "auditIntForwarderConfigId" ||
					v.auditReasonCode != "AR_0005"
				) {
					v[name] = val;
				}
			});
			if (name == "auditReasonCode" && val == "AR_0005") {
				this.reviewData.deliveryReviewSpuList[
					index
				].deliveryReviewDetailList.forEach((v) => {
					v.auditIntForwarderConfigId = "-1";
				});
				this.reviewData.deliveryReviewSpuList[index].auditIntForwarderConfigId =
					"-1";
			}
		},
		wholeReasonChange(e) {
			console.log("wholeReasonChange", e);
			if (e == "AR_0005") {
				this.reviveForm.auditIntForwarderConfigId = "-1";
				this.forwarderChange("-1");
			}
		},
		//dialog货代公司change回调
		forwarderChange(e) {
			console.log("forwarderChange", e);
			let data = this.forwarder.filter(
				(item) => item.intForwarderConfigId == e
			)[0];
			this.reviveForm.auditIntForwarderConfigId = e;
			this.reviveForm.auditShippingType = data.shippingType;
			this.reviveForm.auditForwarder = data.forwarder;
			this.$forceUpdate();
		},
		reviewSubmit(next = false) {
			let skuList = this.reviewData.deliveryReviewSpuList
				.map((v) => {
					return v.deliveryReviewDetailList;
				})
				.flat();
			if (this.activeRadio == 0) {
				let warning = skuList.some(
					(v) =>
						Number(v.auditReasonCode) || Number(v.auditIntForwarderConfigId)
				);
				if (warning) {
					this.$confirm(
						`你对SKU选择了异常原因、建议货代公司，是否选择【合理】的审核结果，提交后单据状态会变为已处理，不需要客户确认`,
						"提示",
						{
							confirmButtonText: "是的，继续提交",
							type: "error",
							cancelButtonText: "不，我再想想",
						}
					).then(() => {
						this.submitConnect(next);
					});
					return;
				}
				this.submitConnect(next);
			}
			if (this.activeRadio == 1) {
				this.$refs.reviveForm.validate((v, obj) => {
					if (!v) {
						return false;
					} else {
						let warning = skuList.some(
							(v) =>
								Number(v.auditReasonCode) || Number(v.auditIntForwarderConfigId)
						);
						if (warning && skuList.length > 1) {
							this.$confirm(
								`你对SKU选择了异常原因、建议货代公司，是否选择【不合理，整单更换货代公司】的审核结果，提交后会按照整单修改货代公司`,
								"提示",
								{
									confirmButtonText: "是的，继续提交",
									type: "error",
									cancelButtonText: "不，我再想想",
								}
							).then(() => {
								this.submitConnect(next);
							});
							return;
						}
						this.submitConnect(next);
					}
				});
			}
			if (this.activeRadio == 2) {
				if (skuList.some((v) => v.auditIntForwarderConfigId == -2)) {
					return;
				}
				if (
					skuList.every(
						(v) =>
							(!v.auditReasonCode || v.auditReasonCode == "AR_0000") &&
							!Number(v.auditIntForwarderConfigId)
					)
				) {
					this.$confirm(
						`你没有选择任一SKU的异常原因、建议货代公司，请检查`,
						"提示",
						{
							confirmButtonText: "我知道了",
							showCancelButton: false,
							type: "error",
						}
					);
					return;
				}
				if (
					skuList.some(
						(v) =>
							v.auditReasonCode &&
							v.auditReasonCode != "AR_0000" &&
							!Number(v.auditIntForwarderConfigId)
					)
				) {
					return;
				}
				if (
					skuList.some(
						(v) =>
							Number(v.auditIntForwarderConfigId) &&
							(!v.auditReasonCode || v.auditReasonCode == "AR_0000")
					)
				) {
					return;
				}
				let sameShip = skuList.findIndex(
					(v) =>
						v.auditIntForwarderConfigId != skuList[0].auditIntForwarderConfigId
				);
				let sameReason = skuList.findIndex(
					(v) => v.auditReasonCode != skuList[0].auditReasonCode
				);
				if (
					(sameShip == -1 && sameReason == -1 && skuList.length > 1) ||
					skuList.length == 1
				) {
					this.$confirm(
						`你对所有SKU都选择了同样的异常原因和建议货代公司，请选择【整单修改货代公司】`,
						"提示",
						{
							confirmButtonText: "我知道了",
							showCancelButton: false,
							type: "error",
						}
					);
					return;
				}
				if (
					skuList.some((v) => v.auditIntForwarderConfigId === "-1") &&
					this.prentType != "smallBag" &&
					this.prentType != "largeBag"
				) {
					this.$confirm(
						`大包发货单存在无可用货代公司的商品，请选择【整单修改货代公司】`,
						"提示",
						{
							confirmButtonText: "我知道了",
							showCancelButton: false,
							type: "error",
						}
					);
					return;
				}
				this.submitConnect(next);
			}
		},
		async submitConnect(next) {
			// 校验整单不合理时sku异常与整单异常是否匹配
			if (this.activeRadio === 1) {
				const checkData = await checkAbnormalDeliveryReviewApi({
					auditReasonCode: this.reviveForm.auditReasonCode,
					deliveryReviewCodeList: [this.reviewData.deliveryReviewCode],
				});
				console.log(checkData);
				if (checkData.data.failNoList?.length > 0) {
					this.$refs.abnormalDialogRef.open(
						checkData.data.failNoList.map((v) => ({ id: v }))
					);
					return;
				}
			}
			let params = {
				// "auditDistribution": this.reviewData.auditDistribution,
				// "auditIntShipConfigId": this.reviewData.auditIntShipConfigId,
				deliveryReviewCode: this.reviewData.deliveryReviewCode,
				auditRemark: this.reviveForm.remark,
				auditType: this.activeRadio,
				...this.sourceShipConfig,
			};
			if (this.activeRadio == 2) {
				// params.auditSkuList = this.reviewData.deliveryReviewSpuList.map(v=>{return v.deliveryReviewDetailList}).flat().map(v=>{
				//   let auditIntForwarderConfigId = (v.auditIntForwarderConfigId && v.auditIntForwarderConfigId != 0 )?v.auditIntForwarderConfigId:this.reviewData.logisticsChoose.intForwarderConfigId
				//   return {
				//     deliveryReviewDetailId:v.id,
				//     productSku:v.productSku,
				//     deliveryReviewCode:v.deliveryReviewCode,
				//     auditIntForwarderConfigId:auditIntForwarderConfigId,
				//     auditReasonCode:v.auditReasonCode,
				//     auditForwarder: this.forwarder.filter(y=>y.intForwarderConfigId == auditIntForwarderConfigId)[0].forwarder
				//   }
				// })
				params.auditSkuList = this.reviewData.deliveryReviewSpuList
					.map((y) => {
						return y.deliveryReviewDetailList.map((v) => {
							let auditIntForwarderConfigId =
								v.auditIntForwarderConfigId && v.auditIntForwarderConfigId != 0
									? v.auditIntForwarderConfigId
									: this.reviewData.logisticsChoose.intForwarderConfigId;
							// if(!this.forwarder.filter(z=>z.intForwarderConfigId == y.auditIntForwarderConfigId).length){
							//   this.$message.warning('所选货代公司错误或已失效')
							//   return
							// }
							console.log(
								this.forwarder.filter(
									(z) => z.intForwarderConfigId == y.auditIntForwarderConfigId
								)[0]
							);
							return {
								deliveryReviewDetailId: v.id,
								productSku: v.productSku,
								deliveryReviewCode: v.deliveryReviewCode,
								auditIntForwarderConfigId: auditIntForwarderConfigId,
								auditReasonCode: v.auditReasonCode,
								auditForwarder: this.forwarder.filter(
									(z) => z.intForwarderConfigId == auditIntForwarderConfigId
								)[0]?.forwarder,
								auditSpuReasonCode: y.auditReasonCode,
								auditSpuIntForwarderConfigId: y.auditIntForwarderConfigId,
								auditSpuForwarder: this.forwarder.filter(
									(z) => z.intForwarderConfigId == y.auditIntForwarderConfigId
								)[0]?.forwarder,
								auditSpuShippingType: this.forwarder.filter(
									(z) => z.intForwarderConfigId == y.auditIntForwarderConfigId
								)[0]?.shippingType,
								auditShippingType: this.forwarder.filter(
									(z) => z.intForwarderConfigId == y.auditIntForwarderConfigId
								)[0]?.shippingType,
							};
						});
					})
					.flat();
			}
			if (this.activeRadio == 1) {
				params.auditReasonCode = this.reviveForm.auditReasonCode;
				params.auditForwarder = this.reviveForm.auditForwarder;
				params.auditIntForwarderConfigId =
					this.reviveForm.auditIntForwarderConfigId;
				params.auditShippingType = this.reviveForm.auditShippingType;
			}
			singleReview(params).then(({ code }) => {
				if (code === 0) {
					this.$message.success("成功");
					this.$emit("refeash");
					if (next) {
						this.toReview("next");
					} else {
						this.reviewDialogShow = false;
					}
				}
			});
		},
		skipToNext() {
			this.skip.push(this.reviewData.deliveryReviewCode);
			this.toReview("skip");
		},
		tableForwarderChange(val, record, name, version, auditForwarder = false) {
			console.log(record);
			let params = {
				deliveryReviewCode: record.deliveryReviewCode,
				deliveryReviewDetailId: record.id,
				remark: record.remark || "",
				// auditIntForwarderConfigId: record.auditIntForwarderConfigId,
				// auditReasonCode: record.auditReasonCode,
				version: version,
			};
			params[name] = val;
			//货代名字
			auditForwarder &&
				val != 0 &&
				(params.auditForwarder = this.onSelectForwarderList.filter(
					(v) => v.intForwarderConfigId == val
				)[0].forwarder);

			if (name == "auditReasonCode" && val == "AR_0005") {
				params.auditIntForwarderConfigId = "-1";
				params.auditForwarder = "无可用货代公司";
			}
			abnormalCommit_sku(params)
				.then(({ code }) => {
					if (code == 0) {
						this.$message.success("修改成功");
					}
				})
				.finally(() => {
					this.$emit("refeash");
				});
		},
		tableReasonChange(val, record) {
			let targetReason = this.reasonList.filter((i) => i.zh == val)[0];
			let params = {
				deliveryReviewCode: record.deliveryReviewCode,
				deliveryReviewDetailId: record.id,
				remark: record.remark || "",
				auditIntForwarderConfigId: record.auditIntForwarderConfigId,
				auditReasonJp: targetReason.ja,
				auditReason: val,
			};
			abnormalCommit_sku(params)
				.then(({ code }) => {
					if (code == 0) {
						this.$message.success("修改成功");
					}
				})
				.finally(() => {
					this.$emit("refeash");
				});
		},
		tableForwarderChange_spu(
			val,
			record,
			name,
			deliveryReviewCode,
			version,
			auditForwarder = false
		) {
			let forwarder;
			auditForwarder &&
				val != 0 &&
				(forwarder = this.onSelectForwarderList.filter(
					(v) => v.intForwarderConfigId == val
				)[0].forwarder);
			let params = {
				deliveryReviewCode: deliveryReviewCode,
				version: version,
				skuList: record.deliveryReviewDetailList.map((v) => {
					let item = {
						remark: v.remark || "",
						deliveryReviewDetailId: v.id,
						// auditIntForwarderConfigId: v.auditIntForwarderConfigId
					};
					if (
						name != "auditIntForwarderConfigId" ||
						v.auditReasonCode != "AR_0005"
					) {
						item[name] = val;
					}
					if (auditForwarder && val != 0) {
						item.auditForwarder = forwarder;
					}
					if (name == "auditReasonCode" && val == "AR_0005") {
						item.auditIntForwarderConfigId = "-1";
						item.auditForwarder = "无可用货代公司";
					}
					return item;
				}),
			};
			abnormalCommit_spu(params)
				.then(({ code }) => {
					if (code == 0) {
						this.$message.success("修改成功");
					}
				})
				.finally(() => {
					this.$emit("refeash");
				});
		},
		saveDeclaration() {
			this.$refs.saveDeclarationDataForm.validate((v, obj) => {
				if (v) {
					let targetCustom = this.customsList.filter(
						(v) =>
							v.productCustomsId ==
							this.saveDeclarationData.productDeclarationId
					)[0];
					if (!targetCustom) {
						this.$message.warning("品名失效");
						return false;
					}
					let params = {
						deliveryReviewDetailId: this.saveDeclarationData.id,
						productSku: this.saveDeclarationData.productSku,
						productDeclarationId: targetCustom.productCustomsId,
						productItemCategoryZh: targetCustom.productItemCategoryZh,
						productItemCategoryEn: targetCustom.productItemCategoryEn,
						customsCode: targetCustom.customsCode,
						// compilationMethod: this.saveDeclarationData.compilationMethod,
					};
					customsConfirm(params).then(({ code, data }) => {
						if (code == 0) {
							this.$message.success("成功");
							this.saveDeclarationInfoVisible = false;
							this.$emit("refeash");
						}
					});
				}
			});
			// let dataSource = [...this.dataSource]

			// let data = this.forwarder.filter(item => item.intForwarderConfigId == val)[0]
			// dataSource[index].auditIntForwarderConfigId = val
			// dataSource[index].auditShippingType = data.shippingType
			// dataSource[index].auditForwarder = data.forwarder

			// this.$emit('tableForwarderChange', dataSource)
		},
		selectOnfocus(e, r, deliveryItem = "") {
			console.log(r);
			this.selectLoading = true;
			this.onSelectForwarderList = [];
			let params;
			if (deliveryItem) {
				params = {
					warehouse: deliveryItem.warehouse,
					deliveryType: deliveryTypes[this.prentType],
					systemSource: deliveryItem.systemSource,
					auditIntForwarderConfigId: deliveryItem.auditIntForwarderConfigId,
					receivingNationCode: deliveryItem.receivingNationCode,
					deliveryTaskCode: deliveryItem.deliveryTaskCode,
					processingStatus: processingStatusList[this.$attrs.tableType],
				};
			} else {
				params = {
					warehouse: r.warehouse,
					deliveryType: deliveryTypes[this.prentType],
					systemSource: r.systemSource,
					auditIntForwarderConfigId: r.logisticsChoose.intForwarderConfigId,
					receivingNationCode: r.receivingNationCode,
					deliveryTaskCode: r.deliveryTaskCode,
					processingStatus: processingStatusList[this.$attrs.tableType],
				};
			}
			getClientForwarder(params).then(({ code, data }) => {
				if (code == 0) {
					this.onSelectForwarderList = [
						{
							forwarder: "无可用货代公司",
							intForwarderConfigId: "-1",
							shippingType: 0,
						},
					].concat(data);
					this.selectLoading = false;
				}
			});
		},
		upError(record) {
			let params = {
				deliveryReviewCode: record.deliveryReviewCode,
			};
			abnormalCommit(params).then(({ code, data }) => {
				if (code == 0) {
					this.$message.success("成功");
					this.$emit("refeash");
				}
			});
		},
		editRemark(record) {
			this.editRemarkInfo = record;
			this.editRemarkVisible = true;
		},
		confirmRemark() {
			let params = {
				deliveryReviewCode: this.editRemarkInfo.deliveryReviewCode,
				deliveryReviewDetailId: this.editRemarkInfo.id,
				auditRemark: this.editRemarkInfo.auditRemark,
			};
			abnormalCommit_sku(params).then(({ code }) => {
				if (code == 0) {
					this.$message.success("修改成功");
					this.$emit("refeash");
					this.editRemarkVisible = false;
				}
			});
		},
		disabledSelect(r) {
			return r.auditReasonCode == "AR_0005";
		},
		examineAgain(record) {
			this.$confirm(
				"确认后选中订单将清空审单结果，退回到待处理中重新审单",
				"提示",
				{
					type: "warning",
					closeOnPressEscape: false,
					closeOnClickModal: false,
				}
			).then(() => {
				deliveryReviewApi({
					deliveryReviewCode: record.deliveryReviewCode,
				}).then((res) => {
					console.log("res", res);
					if (!res.success) return;
					this.$message.success("操作成功");
					this.$emit("refeash");
				});
			});
		},
		async jumpAliWangwang(record) {
			const { platformType, shopCode } = record;
			const shopCustomerServiceId = this.serviceIds[shopCode];
			// 天猫淘宝
			if (["TB", "TM"].includes(platformType)) {
				window.open(
					`https://market.m.taobao.com/app/im/chat/index.html?&uid=cntaobao${shopCustomerServiceId}&gid=&type=web#/`
				);
			}
			// 1688
			if (["AM"].includes(platformType)) {
				window.open(
					`https://air.1688.com/app/ocms-fusion-components-1688/def_cbu_web_im/index.html?touid=cnalichn${shopCustomerServiceId}&siteid=cnalichn&status=1`
				);
			}
		},
		changeAttribute(row) {
			console.log(row);
			updateSkuTransportationAttrApi({
				deliveryReviewDetailId: row.id,
				codeList: row.attrCodes,
			}).then((res) => {
				if (!res.success) return;
				this.$message.success("保存成功");
				row.isEdit = false;
				this.$emit("refeash");
			});
		},
		openRemark(text) {
			this.$refs.remarkDialogRef.open(text);
		},
		sortList(scope, isSort) {
			const row = scope.row;
			if (this.activeRadio === 2 || isSort) {
				// 重新排序 有异常的排在前面
				let list = [...this.reviewData.deliveryReviewSpuList];
				const isAbormal =
					(row.auditReasonCode &&
						row.auditReasonCode !== "AR_0000" &&
						row.auditIntForwarderConfigId &&
						row.auditIntForwarderConfigId !== "0") ||
					row.deliveryReviewDetailList?.some(
						(t) =>
							t.auditReasonCode &&
							t.auditReasonCode !== "AR_0000" &&
							t.auditIntForwarderConfigId &&
							t.auditIntForwarderConfigId !== "0"
					);
				if (!isSort) {
					if (row.isHave && isAbormal) return;
					if (!row.isHave && !isAbormal) return;
				}
				const abList = [];
				const norList = [];
				list.forEach((item) => {
					if (item.productCode === row.productCode) return;
					if (
						(item.auditReasonCode &&
							item.auditReasonCode !== "AR_0000" &&
							item.auditIntForwarderConfigId &&
							item.auditIntForwarderConfigId !== "0") ||
						item.deliveryReviewDetailList?.some(
							(t) =>
								t.auditReasonCode &&
								t.auditReasonCode !== "AR_0000" &&
								t.auditIntForwarderConfigId &&
								t.auditIntForwarderConfigId !== "0"
						)
					) {
						abList.push(item);
					} else {
						norList.push(item);
					}
				});
				if (!isSort) {
					if (isAbormal) {
						abList.unshift(row);
					} else {
						norList.unshift(row);
					}
				}
				this.reviewData.deliveryReviewSpuList = [
					...abList.map((item) => ({ ...item, isHave: true })),
					...norList.map((item) => ({ ...item, isHave: false })),
				];
			}
		},
		openDeclarationCodeModal(record, type) {
			this.$refs.declarationCodeModalRef.open(record, type);
		},
		openThirdUrl(record) {
			window.open(record.productLink);
		},
		submitDeclarationCode(record, type) {
			if (type === 2) {
				this.checkCombinationProduct();
			}
			this.$emit("refeash");
		},
		submitEditProductCategoryZh(record, type) {
			if (type === 2) {
				// 组合商品弹窗
				this.checkCombinationProduct();
			}
			this.$emit("refeash");
		},
	},
	mounted() {
		getTransportationAttributesListApi().then((res) => {
			this.transportationAttributesList = res.data;
		});
	},
};
</script>

<style scoped>
.ant-table-expanded-row .son__table--customize >>> td,
.son__table--customize >>> th {
	border-right: 0px solid #e8e8e8 !important;
}

.shipmentCode__span {
	position: relative;
	top: 0;
	left: 0;
	display: block;
	line-height: 24px;
}

.shipment__error::before {
	position: absolute;
	bottom: 0;
	left: 0;
	content: "运单号获取异常";
	display: block;
	height: 24px;
	line-height: 24px;
	font-size: 12px;
	color: red;
}

.span__btn {
	cursor: pointer;
	padding: 1px 0;
	margin: 2px;
	color: #40a9ff;
}

::v-deep .headerClass {
	background-color: #ddeefe !important;
}

::v-deep .ant-table-expand-icon-th,
.ant-table-row-expand-icon-cell {
	width: 50px !important;
}

::v-deep .el-dialog__header {
	/* padding: 10px 20px 0; */
	padding: 0px 0px 0px 0px !important;
}

::v-deep .el-dialog__body {
	padding: 5px 20px;
}

::v-deep .el-collapse-item__content {
	padding-bottom: 0px;
}

::v-deep .el-descriptions__header {
	margin-bottom: 5px;
}

::v-deep .el-dialog {
	margin: 0 auto;
}

.dialogTitle {
	height: 60px;
	width: 100%;
	font-size: 20px;
	text-align: center;
	line-height: 60px;
	background-color: #00284d;
	color: #e8e8e8;
}

.shipForm .el-form-item {
	margin-bottom: 0px;
}

.platformOrderNo {
	display: flex;
	align-items: center;
}

.platformOrderNo .mini-tag {
	margin-left: 4px;
	border: 1px solid #00284d;
	padding: 0 4px;
  white-space: nowrap;
  margin-right: 4px;
}
</style>

<style>
.transportation-attr-code-select {
	z-index: 4000;
}

.tableWarning {
	position: absolute;
	bottom: -5px;
	left: 10px;
	color: red;
	width: 150px;
}

.el-select-dropdown {
	max-width: 500px;
}

.productPriceInput .el-input input {
	background-color: #fff !important;
	cursor: text !important;
}

.popperClass {
	width: 400px;
}
</style>
